import React from "react";
import "./App.css";
import CVWebsite from "./components/CVWebsite";

function App() {
  return (
    <div className="App">
      <CVWebsite />
    </div>
  );
}

export default App;
